import React from 'react';

import useMediaQuery from 'utils/useMediaQuery';
import { ListItem, ListItemProps, ListItemSize } from 'components/List/ListItem';
import { Colors } from 'enums/Colors';

import styles from './WrappedList.module.scss';

interface Props {
  items: ListItemProps[];
  transparentBg?: boolean;
}

export const WrappedList: React.FC<Props> = ({ items, transparentBg = false }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <ul className={styles.wrapper}>
      {items?.map((item) => (
        <div
          key={item.label}
          className={`${styles['item-wrapper']} ${transparentBg ? styles.transparent : null}`}
        >
          <ListItem
            label={item.label}
            value={item.value}
            size={isMobile ? ListItemSize.Small : ListItemSize.Normal}
            labelColor={transparentBg ? Colors.White : Colors.DarkBlue100}
            valueColor={Colors.White}
          />
        </div>
      ))}
    </ul>
  );
};
